import api from './api';

export const faqAPI = {
  getAllFAQs: async (params: { page?: number; limit?: number; search?: string; isActive?: boolean }) => {
    const response = await api.get('/faq/getall', { params });
    return response.data;
  },
  createFAQ: async (data: { question: string; answer: string; isActive?: boolean }) => {
    const response = await api.post('/faq/create', data);
    return response.data;
  },
  updateFAQ: async (id: string, data: { question?: string; answer?: string; isActive?: boolean }) => {
    const response = await api.put(`/faq/update/${id}`, data);
    return response.data;
  },
  deleteFAQ: async (id: string) => {
    const response = await api.delete(`/faq/delete/${id}`);
    return response.data;
  },
};